import React from 'react';
import { Box, FormControl, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material';
import { Reason } from './PhysicianReviewSecondPart';

interface DecisionReasonSelectProps {
    value: Reason['value'] | null;
    reasons: Reason[];
    onChange: (value: Reason['value']) => void;
    error?: boolean;
}

const DecisionReasonSelect = ({ value, reasons, onChange, error }: DecisionReasonSelectProps) => {
    return (
        <FormControl sx={{ margin: 0, width: 293 }} size="small" error={error}>
            <Select
                displayEmpty
                value={reasons.length > 0 ? value ?? '' : ''}
                onChange={(e) => onChange(e.target.value as Reason['value'])}
                input={<OutlinedInput />}
                renderValue={(selected) => {
                    if (!selected) return 'Decision Reason';

                    return reasons.find((r) => r.value === selected)?.text ?? 'Decision Reason';
                }}
                sx={{
                    borderRadius: '8px',
                    fontWeight: 600,
                    fontSize: '14px'
                }}>
                {reasons.map((reason) => (
                    <MenuItem key={reason.value} value={reason.value}>
                        <ListItemText primary={reason.text} />
                    </MenuItem>
                ))}
            </Select>

            {error && (
                <Box
                    sx={{
                        color: 'error.main',
                        textAlign: 'center',
                        marginTop: '0.25rem'
                    }}>
                    Please select a reason
                </Box>
            )}
        </FormControl>
    );
};

export default DecisionReasonSelect;
